import 'normalize.css';
//import 'bootstrap/dist/css/bootstrap.css';
import 'flexboxgrid/css/flexboxgrid.css';
import 'tingle.js/dist/tingle.min.css';
import '../sass/main.scss';
import '../icons.json';
import { FrontBanner } from '../sass/front/banner';
import { MainMenu } from '../sass/shared/menu';
import { ListingLoader } from '../sass/shared/listing';
import { DynamicForm } from '../sass/shared/form';
import { ProductDownloads } from '../sass/components/product-downloads/product-downloads';
import { ContactFooter } from '../sass/shared/contact-footer';
import { ProductImages } from '../sass/product/product-images';

new FrontBanner;
new MainMenu;
new ListingLoader;
new DynamicForm;
new ProductDownloads;
new ContactFooter;
new ProductImages;


// WEBPACK FOOTER //
// ./assets/js/main.js